import { useEffect, useState } from 'react';

import { Field, Label } from '../../ui/catalyst/fieldset';
import { Input } from '../../ui/catalyst/input';
import { Text } from '../../ui/catalyst/text';
import { Textarea } from '../../ui/catalyst/textarea';

interface EncounterFormProps {
  initialData?: {
    date: string;
    description: string;
    services: string[];
  };
  prefix?: string;
  onChange?: (formData: {
    date: string;
    description: string;
    services: string[];
  }) => void;
}

export const EncounterForm = ({
  initialData = {
    date: '',
    description: '',
    services: [],
  },
  prefix = '',
  onChange,
}: EncounterFormProps) => {
  const [formState, setFormState] = useState(initialData);

  useEffect(() => {
    setFormState(initialData);
  }, [initialData]);

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    const { name, value } = e.target;
    const updatedState = { ...formState, [name]: value };
    setFormState(updatedState);
    onChange?.(updatedState);
  };

  const handleServicesChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const services = e.target.value
      .split('\n')
      .filter((service) => service.trim() !== '');
    const updatedState = { ...formState, services };
    setFormState(updatedState);
    onChange?.(updatedState);
  };

  return (
    <form className="space-y-4 my-4">
      <Field>
        <Label htmlFor={`${prefix}date`}>Date of Service</Label>
        <Input
          id={`${prefix}date`}
          name="date"
          type="date"
          value={formState.date}
          onChange={handleInputChange}
        />
      </Field>

      <Field>
        <Label htmlFor={`${prefix}description`}>Description</Label>
        <Textarea
          id={`${prefix}description`}
          name="description"
          value={formState.description}
          onChange={handleInputChange}
          placeholder={
            prefix ? undefined : 'Brief description of the encounter'
          }
          rows={4}
        />
        <Text className="text-xs text-gray-500 mt-1">
          Provide detailed information about the treatment or service provided
        </Text>
      </Field>

      <Field>
        <Label htmlFor={`${prefix}services`}>Services (one per line)</Label>
        <Textarea
          id={`${prefix}services`}
          name="services"
          value={formState.services.join('\n')}
          onChange={handleServicesChange}
          placeholder={
            prefix ? undefined : 'Enter services provided, one per line'
          }
          rows={4}
        />
      </Field>
    </form>
  );
};
